// extracted by mini-css-extract-plugin
export default {"hiddenContent":"hiddenContent---EQ4o1","qlEditor":"qlEditor---QjWJR","pageBreakAfter":"pageBreakAfter---jZ1I0"};